import React, { useState, useEffect } from "react";
import { Button, Box, Typography, Grid } from "@mui/material";
import Header1 from "../Header/Header1";
import axios from "axios";
import MyRequests from "./MyRequests";
import AcceptedRequests from "./AcceptedRequests";

const API_URL = process.env.REACT_APP_API_URL;

function MyRequestsPlatform({ userId, onLogout }) {

  useEffect(() => {
    window.scrollTo(0, 0);  // Scroll to top when this page is loaded
  }, []);


  const [activePage, setActivePage] = useState("my-requests"); // Default active page
  const [searchResults, setSearchResults] = useState([]);
  const [isVerified, setIsVerified] = useState(false);

  const handleSearch = (result) => {
    setSearchResults(result);
  };


  const checkUserVerification = async () => {
    try {
      const response = await axios.get(`${API_URL}/get_verify_user/`, { params: { user_id: userId } });
      if (response.data.status === 'verified') {
        setIsVerified(true);
      } else {
        setIsVerified(false);
      }
    } catch (error) {
      console.error('Error verifying user:', error);
      setIsVerified(false);  // Default to not verified in case of an error
    }
  };

  useEffect(() => {
    checkUserVerification();
  }, [userId]);

  const renderContent = () => {
    switch (activePage) {
      case "my-requests":
        return <MyRequests userId={userId} searchResults={searchResults} />;
      case "accepted-requests":
        return <AcceptedRequests userId={userId} searchResults={searchResults} />;
      default:
        return <Typography variant="h4" color="#ecf0f1">Welcome</Typography>;
    }
  };

  return (
    <div>
      <Header1 userId={userId} page_name={activePage} onSearch={handleSearch} onLogout={onLogout} />

      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },  // Switch flexDirection to column for small screens, row for larger screens
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'black',
          padding: { xs: '0.5rem', sm: '1rem' },  // Smaller padding for small screens, larger padding for larger screens
          width: '100%',
        }}
      >
        <Grid container spacing={2} justifyContent="center" sx={{ flexDirection: { xs: 'column', sm: 'row' }, textAlign: 'center' }}>


          <Grid item>
            <Button
              onClick={() => setActivePage("my-requests")}
              sx={{
                color: activePage === "my-requests" ? "#1E90FF" : "#ecf0f1",
                textTransform: "none",
                letterSpacing: 2,
                fontSize: { xs: '0.9rem', sm: '1rem' },
                width: { xs: '100%', sm: 'auto' },
                "&:hover": {
                  backgroundColor: "#1111",
                },
                padding: { xs: '0.5rem', sm: '1rem' },
              }}
            >
              My Requested Sessions
            </Button>
          </Grid>
          <Grid item>
            <Button
              onClick={() => setActivePage("accepted-requests")}
              sx={{
                color: activePage === "accepted-requests" ? "#1E90FF" : "#ecf0f1",
                textTransform: "none",
                letterSpacing: 2,
                fontSize: { xs: '0.9rem', sm: '1rem' },
                width: { xs: '100%', sm: 'auto' },
                "&:hover": {
                  backgroundColor: "#1111",
                },
                padding: { xs: '0.5rem', sm: '1rem' },
              }}
            >
              My Accepted Sessions
            </Button>
          </Grid>

        </Grid>

      </Box>

      {/* Dynamic Content */}
      <Box
        sx={{
          padding: { xs: "1rem", sm: "2rem" }, // Adjust padding for smaller and larger screens
          backgroundColor: "black",
          color: "white",
          minHeight: "calc(100vh - 64px)", // Keeps the height full minus any fixed header
          display: "flex",
          flexDirection: "column", // Ensure content is stacked vertically on small screens
          justifyContent: "center", // Centers content vertically
          alignItems: "center", // Centers content horizontally
          overflow: "hidden", // Prevents overflow on smaller screens
        }}
      >
        {renderContent()}
      </Box>

    </div>
  );
}

export default MyRequestsPlatform;
